import { render, staticRenderFns } from "./ContactsFragmentDesktopContactList.vue?vue&type=template&id=a0bd47a2&scoped=true&"
import script from "./ContactsFragmentDesktopContactList.vue?vue&type=script&lang=js&"
export * from "./ContactsFragmentDesktopContactList.vue?vue&type=script&lang=js&"
import style0 from "./ContactsFragmentDesktopContactList.vue?vue&type=style&index=0&id=a0bd47a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0bd47a2",
  null
  
)

export default component.exports